import { createElement, ReactNode } from "react";
import classNames from "classnames";

import { ChooserContext } from "~/components/shared/Chooser/context";

interface OptionProps {
  tag?: string;
  children: ReactNode;
  className?: string;
  unselectedClassName?: string;
  selectedClassName?: string;
  value: any;
  data?: any;
}

const Option = ({
  tag = "div",
  children,
  className,
  unselectedClassName,
  selectedClassName,
  value,
  data,
}: OptionProps) => {
  return (
    <ChooserContext.Consumer>
      {(chooser) => {
        if (!chooser) {
          return null;
        }

        const selectionClasses = chooser.isSelected(value)
          ? selectedClassName
          : unselectedClassName;
        const classes = classNames(className, selectionClasses);

        const handleClick = (evt: React.MouseEvent) => {
          evt.preventDefault();
          chooser.handleChoiceClick(value, data);
        };

        return createElement(tag, { className: classes, onClick: handleClick }, children);
      }}
    </ChooserContext.Consumer>
  );
};

export default Option;
